var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.tipos,"label":"Tipo do pedido","item-text":"text","item-value":"value"},model:{value:(_vm.tipoSelecionado),callback:function ($$v) {_vm.tipoSelecionado=$$v},expression:"tipoSelecionado"}})}
var staticRenderFns = []

export { render, staticRenderFns }